import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

// Create an instance of axios
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 180000, // Request timeout (optional)
    headers: {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
    }
});

axiosInstance.interceptors.request.use(
    config => {
        const token = cookies.get('auth_token');
        const tenant = cookies.get('auth_tenant');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        if (tenant) {
            config.headers['tenant'] = tenant;
        }
        config.headers['X-Client-Type'] = 'web';
        // if (config.data instanceof FormData) {
        //     config.headers['Content-Type'] = 'multipart/form-data';
        // } else if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
        //     config.data = transformDataToUrlEncoded(config.data);
        // } else {
        //     config.headers['Content-Type'] = 'application/json,application/pdf';
        // }

        // ✅ Let browser/axios handle Content-Type for FormData
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type']; // Axios sets this with correct boundary
        } else if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            config.data = transformDataToUrlEncoded(config.data);
        } else {
            config.headers['Content-Type'] = 'application/json';
        }

        // // Determine required permission //used this code for prevent API call
        // let requiredPermission = config.permission;
        // const apiPermissionMap = ['api/lead']

        // if (!requiredPermission) {
        //     const path = config.url.split('?')[0]; // remove query params
        //     console.log('path', path)
        //     requiredPermission = 'lead_list';
        // }

        // console.log('requiredPermission', requiredPermission)

        // if (requiredPermission) {
        //     console.log(requiredPermission)
        //     console.warn(`Permission denied for ${config.url} (needs "${requiredPermission}")`);
        //     return Promise.reject({
        //         message: 'Permission denied for this API call.',
        //         isPermissionError: true,
        //         config
        //     });
        // }

        return config;
    },
    error => {
        // Handle request error
        return Promise.reject(error);
    }
);

function transformDataToUrlEncoded(data) {
    const params = new URLSearchParams();
    for (const key in data) {
        params.append(key, data[key]);
    }
    return params;
}

// Do not add the response interceptor here

export default axiosInstance;